// =============================================================================
// PRZYPISANIE LICENCJI DO RODZINY URZĄDZEŃ — jedna czysta funkcja, bo od niej
// zależy, w której zakładce urządzenie w ogóle się pojawi.
//
// PIERWSZEŃSTWO PANELU JEST CELOWE i wynika z realnego przypadku opisanego
// przy karcie diagnostyki: sparowane stanowisko potrafi nieść OBA klucze
// (`display` z wcześniejszego życia tej samej licencji, gdy ten sam tablet
// wisiał wcześniej na ścianie). Bez jawnej kolejności takie urządzenie albo
// zniknęłoby z obu zakładek, albo pokazało się w dwóch — a jego własna
// telemetria mówi, co stoi tam TERAZ.
//
// Klucze modułów to kontrakt między aplikacjami, nie etykiety: `fabrica_panel`
// czyta panel produkcyjny przy parowaniu i BEZ NIEGO ODMAWIA STARTU,
// `display` rysuje aplikacja TV. Nie wolno ich tu przepisać „ładniej".
// =============================================================================

import type { RodzinaUrzadzen } from './katalogWydan';

/** Rodziny, które mają swoją listę urządzeń (serwery wydruku mają własną kartotekę). */
export type RodzinaLicencji = Extract<RodzinaUrzadzen, 'telewizory' | 'mobilne' | 'stanowiska'>;

export interface LicencjaDoKlasyfikacji {
  modules: string[];
  device_info?: { app?: string } | null;
}

export function rodzinaLicencji(licencja: LicencjaDoKlasyfikacji): RodzinaLicencji {
  if (licencja.device_info?.app === 'fabrica-panel') return 'stanowiska';
  if (licencja.modules?.includes('fabrica_panel')) return 'stanowiska';
  if (licencja.modules?.includes('display')) return 'telewizory';
  return 'mobilne';
}

export function policzRodziny<T extends LicencjaDoKlasyfikacji>(
  licencje: T[]
): Record<RodzinaLicencji, number> {
  const liczniki: Record<RodzinaLicencji, number> = { telewizory: 0, mobilne: 0, stanowiska: 0 };
  for (const l of licencje) liczniki[rodzinaLicencji(l)] += 1;
  return liczniki;
}
